export const getIsActiveTab = (
  id: string,
  match: RegExp | undefined,
  pathname: string,
  isOpenSideBar: boolean,
  isIntercomOpen: boolean,
): boolean => {
  switch (id) {
    case 'lobby':
      return pathname === '/' && !!match?.test(pathname) && !isOpenSideBar;

    case 'menu':
      return isOpenSideBar;
    case 'online-support':
      return isIntercomOpen;

    default:
      return !isOpenSideBar && !!match?.test(pathname);
  }
};
